export const WEEK = [
  {
    text: 'Lunes',
    value: 'lunes',
  },
  {
    text: 'Martes',
    value: 'martes',
  },
  {
    text: 'Miercoles',
    value: 'miercoles',
  },
  {
    text: 'Jueves',
    value: 'jueves',
  },
  {
    text: 'Viernes',
    value: 'viernes',
  },
  {
    text: 'Sábado',
    value: 'sabado',
  },
  {
    text: 'Domingo',
    value: 'domingo',
  },
]

export const CHECK_DEFAULT_VALUES = {
  lunes: false,
  martes: false,
  miercoles: false,
  jueves: false,
  viernes: false,
  sabado: false,
  domingo: false,
}
export const DROPDOWN_DEFAULT_VALUES_MIN = {
  start1: null,
  finish1: null,
}

export const DROPDOWN_DEFAULT_VALUES_MAX = {
  start1: null,
  finish1: null,
  start2: null,
  finish2: null,
}
export const SCHEDULE_VALUES = [
  { day: 'lunes', start1: null, finish1: null, start2: null, finish2: null },
  { day: 'martes', start1: null, finish1: null, start2: null, finish2: null },
  { day: 'miercoles', start1: null, finish1: null, start2: null, finish2: null },
  { day: 'jueves', start1: null, finish1: null, start2: null, finish2: null },
  { day: 'viernes', start1: null, finish1: null, start2: null, finish2: null },
  { day: 'sabado', start1: null, finish1: null, start2: null, finish2: null },
  { day: 'domingo', start1: null, finish1: null, start2: null, finish2: null },
]
